import { AppResource } from "@config/config";

export const MapServices = {
  NIOGEMS5_SERVICE: {
    url: AppResource.VITE_NIOGEMS_GIS_URL,
    title: "TEST F — MapImageLayer (No Client Clustering)",
    visible: false,
    isExcluded: false,

    sublayers: [
      {
        id: 0,
        visible: false,
        title: "Wells (MapImageLayer)",
      },
    ],
  },
};